import React from 'react';
import PropTypes from 'prop-types';

import Image from 'marketing-website/components/modules/Image';
import LaboratoriaLogo from 'marketing-website/media/images/pages/case-studies/laboratoria/laboratoria-full.png';

export default function LaboratoriaFull({ size }) {
  return <Image maxWidth={size} src={LaboratoriaLogo} hasShadow={false} />;
}

LaboratoriaFull.propTypes = {
  size: PropTypes.number,
};

LaboratoriaFull.defaultProps = {
  size: 180,
};



// WEBPACK FOOTER //
// ./src/components/icons/LaboratoriaFull/index.js